import styled from 'styled-components';

import { breakpoints } from '../../global-styles';

import { Icon } from '@controlrooms/components';
import { ICONS } from '@controlrooms/constants';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 0 10px;
  cursor: pointer;
  &:hover > div {
    color: ${({ theme }) => theme.timeDisplay.primaryTextHover};
    filter: drop-shadow(0px 0px 8px #80f7ff);
    * {
      color: ${({ theme }) => theme.timeDisplay.primaryTextHover};
    }
  }
`;

export const TimeContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
`;

export const TimeRangeContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  margin-top: 5px;
`;

export const DurationContainer = styled.div`
  font-weight: 300;
  font-size: 11px;
  font-family: 'Open Sans', sans-serif;
  color: ${({ theme }) => theme.timeDisplay.secondaryTextColor};

  ${breakpoints.xl} {
    font-size: 17px;
  }
`;

export const TimeCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0;
`;

export const Label = styled.div`
  font-style: normal;
  font-weight: 400;
`;

export const PrimaryLabel = styled(Label)`
  font-size: 21px;
  font-weight: 400;
  line-height: 23px;
  margin-right: 7px;
  ${breakpoints.low} {
    font-size: 16px;
  }
  color: ${({ theme }) => theme.timeDisplay.primaryTextColor};

  .date {
    font-weight: 300;
    color: ${({ theme }) => theme.timeDisplay.secondaryTextColor};
  }
  ${breakpoints.xl} {
    font-size: 31px;
  }
`;

export const SubLabel = styled(Label)`
  font-size: 15px;
  line-height: 19px;
  color: ${({ theme }) => theme.timeDisplay.secondaryTextColor};

  .time {
    color: ${({ theme }) => theme.timeDisplay.primaryTextColor};
  }
`;

export const TimeZone = styled(SubLabel)`
  font-weight: 400;
  font-size: 11px;
  font-family: 'Open Sans', sans-serif;

  ${breakpoints.xl} {
    font-size: 13px;
  }
`;

export const Separator = styled.div`
  font-size: 20px;
  margin: 0 10px;
  font-weight: 600;
  line-height: 24px;
`;

export const Chevron = styled(Icon).attrs((props) => ({
  color: props.theme.timeDisplay.chevronColor,
  name: ICONS.Chevron,
}))``;

export const TimeSelectContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.modal.containerBorderColor};
  width: 100%;
  height: 100%;

  .date-time-range-input {
    margin-top: 8px;
  }
`;
